export default "__VITE_ASSET__516ea57e__"